import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { NumberInput } from 'ui-components/components/number-input';

import { useFillTimeSla } from '../../../../../../hooks/use-user-setting';
import ModalPortal from '../../../../../../components/modal-portal';
import { UserSettings } from '../../../../../../enums/user-settings/user-settings';
import { saveUserSetting } from '../../../../../../store/user/user.actions';

import messages from './messages';
import style from './style.module.less';

const ChangeSlaModal = ({ onClose }) => {
  const sla = useFillTimeSla();
  const [slaValue, setSlaValue] = useState(sla);
  const dispatch = useDispatch();

  const onSaveClicked = useCallback(() => {
    dispatch(
      saveUserSetting({
        settingName: UserSettings.fillTimeSla.settingName,
        settingValue: slaValue.toString(),
        excludeV3prefix: true,
      }),
    );
    onClose();
  }, [slaValue, dispatch, onClose]);

  const onHandleChange = useCallback((val) => setSlaValue(Math.floor(val)), []);

  return (
    <ModalPortal onClose={onClose}>
      <Modal size='small'>
        <ModalHeader>
          <FormattedMessage {...messages.title} />
        </ModalHeader>
        <ModalBody className={style.body}>
          <FormattedMessage {...messages.description} />
          <p>
            <FormattedMessage {...messages.notShownToCustomerNotice} />
          </p>
          <label className={style['sla-input-label']}>
            <FormattedMessage {...messages.slaLabel} />
          </label>
          <NumberInput className={style['sla-input']} max={96} min={1} onChange={onHandleChange} value={slaValue} />
          <span className={style['sla-helper-text']}>
            <FormattedMessage {...messages.slaHelperText} />
          </span>
        </ModalBody>
        <ModalFooter>
          <ModalFooterCancelButton />
          <Button disabled={slaValue === undefined} onClick={onSaveClicked} theme='primary'>
            <FormattedMessage {...messages.saveButton} />
          </Button>
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

ChangeSlaModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ChangeSlaModal;
